import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import SearchForm from '../SearchForm';
import Title from '../Title';
import Card from '../Card';
import { getAlgoliaSearchHcProviderData, getPatientsHcProvider } from '../../app/actions/appActions';
import { changeAccountInformation } from '../../app/actions/authActions';
import { hideAlert, setLightFooter } from '../../app/actions/uiActions';

import './styles.scss';

const Home = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const auth = useSelector((state) => state.firebase.auth);
	const userId = useSelector((state) => state.firebase.profile.userId);
	const availableViruses = useSelector((state) => state.firestore.ordered.available_viruses);

	const handleSearchForm = (value) => {
		if(value) {
			history.push(`/search?q=${value}`);
			dispatch(getAlgoliaSearchHcProviderData({value, hcProviderId: auth.uid}));
		};
	};

	useEffect(()=>{
		dispatch(getPatientsHcProvider(auth.uid))
		dispatch(hideAlert());
		dispatch(setLightFooter(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]); 
	
	useEffect(()=>{
		if(userId) {
			dispatch(changeAccountInformation({email: auth.email}));
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[userId]); 

	return (
		<div className="home">
			<div className="container">
				<div className="home__search">
					<SearchForm onSubmit={handleSearchForm}/>
				</div>
				<Title text={'Virus Listing'}/>
				<div className="home__virus-lists">
					{availableViruses && 
						availableViruses.map((virus,i) => (
							<Card virus={virus} key={i}/>
						))
					}
				</div>
			</div>
		</div>
	);
};

export default Home;
